export default __webpack_public_path__ + "static/media/burjeel-round-check.81d3a45f.svg";